import {LitElement} from "lit";
import {DOMBindingResolver} from "./DOMBindingResolver.js";

export class ResolvingLitElement extends LitElement {

    constructor() {
        super();
        this._resolver = new DOMBindingResolver(this);
    }

    /**
     * @template T
     * @param {function(new:T)} abstract
     * @return {T}
     */
    _resolve(abstract) {
        return this._resolver.resolve(abstract);
    }

    /**
     * The same as resolve() but for string bindings.
     *
     * @param {string} binding
     * @return {Object}
     * @protected
     */
    _get(binding) {
        return this._resolver.get(binding);
    }

    /**
     * Resolve a binding by yourself. If child elements ask, you will deliver.
     * @param {function|string} abstract
     * @param {function} handler
     * @protected
     */
    _resolveBy(abstract, handler) {
        DOMBindingResolver.handleResolveEvent(this, abstract, handler);
    }

    /**
     * @template {Promise} P
     * @param {P} promise
     * @return {P}
     * @protected
     */
    _publishJob(promise) {
        let event = new CustomEvent('pending-state', {
            composed: true,
            bubbles: true,
            detail: {promise: promise}
        });
        this.dispatchEvent(event);
        return promise;
    }
}